import { ApiService } from '@flicent/fieldpulse-react-component-library-frontend';

import { API_ORIGIN } from '@/constants';


export const ApiServiceInstance = new ApiService(typeof API_ORIGIN === 'string' ? API_ORIGIN : '');